import { Button, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useRemoveFavouritePassengerMutation } from "@/redux/apis/favouritePassenger/favouritePassengerApi";
import { FavouritePassenger } from "@/redux/apis/favouritePassenger/types";
import { addToast, showSnackbar } from "@/utils";

interface RemoveGuestModalProps {
  open: boolean;
  guest: FavouritePassenger;
  accountId?: string;
  onClose: () => void;
}

export const RemoveGuestModal = ({ open, guest, accountId, onClose }: RemoveGuestModalProps) => {
  const [removePassenger, { isLoading }] = useRemoveFavouritePassengerMutation();

  const guestName = `${guest.first_name} ${guest.last_name}`.trim();

  const handleRemove = () => {
    removePassenger({ passengerId: guest.uuid, accountId })
      .unwrap()
      .then(() => {
        showSnackbar({ size: "small", duration: 5000, message: `Removed guest ${guestName}` });
        onClose();
      })
      .catch((error) => addToast("danger", getErrorMessages(error)[0]));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      variant="web-small"
      title="Remove Guest"
      renderButtons={() => (
        <>
          <Button variant="tertiary" size="md" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="md"
            className="border-danger bg-danger hover:bg-danger-dark"
            onClick={handleRemove}
            disabled={isLoading}
          >
            Remove
          </Button>
        </>
      )}
    >
      <Typography className="text-neutral-dark-gray">
        Are you sure you want to remove <span className="text-info">{guestName}</span> from your favourite list?
      </Typography>
    </Modal>
  );
};
